import React, { useState } from 'react';
import { Button, Paper, Typography, TextField } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';

import NewPassword from '../NewPassword';
import { checkEmail } from '../../../actions/authentication';
import { setToken } from '../../../helpers/localStorageCache';

function NewUser({ classes }) {
  const [error, setError] = useState({});
  const [email, setEmail] = useState('');
  const [region, setRegion] = useState('');
  const dispatch = useDispatch();
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [changePassword, setChangePassword] = useState(false);

  function handleSubmit(e) {

    setToken('region', region);
    e.preventDefault();

    if (!email) {
      return setError({ message: 'email invalid' });
    }

    setSubmitDisabled(true);

    return dispatch(checkEmail({ email })).then((res) => {
      if (res.error) {
        setError({ message: 'email invalid' });
        return setSubmitDisabled(false);
      }

      setChangePassword(true);
      return setSubmitDisabled(false);
    });
  }

  if (changePassword) {
    return (
      <Paper className={classes.paper} elevation={0}>
        <NewPassword
          changePassword
          classes={classes}
          email={email}
        />
      </Paper>
    );
  }

  return (
    <Paper className={classes.paper} elevation={0}>
      <Typography component="h1" variant="h5" className={classes.loginHeading}>
        Set Password
      </Typography>

      {!isEmpty(error) && <Typography className={classes.errorMessage}>{error.message}</Typography>}

      <form onSubmit={handleSubmit}>
      <Typography gutterBottom variant="h6" className={classes.heading}>
          Region
        </Typography>

        <TextField
          required
          fullWidth
          error={Boolean(error.email)}
          name="region"
          variant="outlined"
          placeholder="EX. west-1a"
          type="name"
          className={classes.field}
          value={region}
          helperText={error.email}
          onChange={e => setRegion(e.target.value)}
        />
        <Typography gutterBottom variant="h6" className={classes.heading}>
          Email
        </Typography>

        <TextField
          required
          fullWidth
          error={Boolean(error.email)}
          name="username"
          variant="outlined"
          placeholder="user@mail.com"
          type="email"
          className={classes.field}
          value={email}
          helperText={error.email}
          onChange={e => setEmail(e.target.value)}
        />

        <Button fullWidth className={classes.submitButton} type="submit" disabled={submitDisabled}>
          Set Password
        </Button>
      </form>
    </Paper>
  );
}

export default NewUser;
